import { CLEAR_PROFILE, GET_PROFILE } from './actions/userprofile'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { router } from '@/router'

const AuthRepository = RepositoryFactory.get('auth')
const token = localStorage.getItem('auth-token')
const initialState = {
  token: token || '',
  status: token ? 2 : 0,
  errorLogin: null,
}

export default {
  namespaced: true,
  state: initialState,
  getters: {
    isAuth: state => Boolean(state.token),
    getToken: state => state.token,
    authStatus: state => state.status,
    getErrorLogin: state => state.errorLogin,
  },
  actions: {
    authLogin: ({ commit, dispatch }, { login, code }) => {
      AuthRepository.login(login, code)
        .then(res => dispatch('authReady', res.data))
        .catch(e => {
          commit('AUTH_ERROR', 'Ошибка')
          commit(`userProfile/${CLEAR_PROFILE}`, null, { root: true })
        })
    },
    authRegister: ({ commit, dispatch }, { login, code }) => {
      AuthRepository.register(login, code)
        .then(resp => dispatch('authReady', resp.data))
        .catch(e => {
          commit('AUTH_ERROR', 'Ошибка')
          commit(`userProfile/${CLEAR_PROFILE}`, null, { root: true })
        })
    },
    authReady: ({ commit, dispatch }, data) => {
      const { user_type, token } = data

      localStorage.setItem('auth-token', token)

      if (user_type === 1) {
        localStorage.setItem('admin-token', token)
      }
      if (user_type === 6) {
        localStorage.setItem('ceo-token', token)
      }
      dispatch(`userProfile/${GET_PROFILE}`, user_type, { root: true }).then(
        () => {
          commit('AUTH_SUCCESS', token)
        },
      )
    },
    authLogout: ({ commit }) => {
      commit(`userProfile/${CLEAR_PROFILE}`, null, { root: true })
      commit('AUTH_LOGOUT')
      router.push('/intro')
    },
    setErrorLogin: ({ commit }, data) => {
      commit('SET_ERROR_LOGIN', data)
    },
  },
  mutations: {
    AUTH_SUCCESS: (state, token) => {
      state.status = 'success'
      state.token = token
    },
    AUTH_ERROR: (state, payload) => {
      localStorage.removeItem('auth-token')
      localStorage.removeItem('admin-token')
      localStorage.removeItem('ceo-token')
      state.status = 1
      state.errorLogin = payload
    },
    AUTH_LOGOUT: state => {
      localStorage.removeItem('auth-token')
      localStorage.removeItem('admin-token')
      localStorage.removeItem('ceo-token')
      state.token = ''
      state.status = 0
    },
    SET_ERROR_LOGIN: (state, payload) => {
      state.errorLogin = payload
    },
  },
}
